import { LANGUAGE_CODES, LANGUAGE_NAMES } from '@terros/common'

export const LANGUAGE_OPTIONS = LANGUAGE_CODES.map((code) => {
  return {
    label: LANGUAGE_NAMES[code],
    value: code,
  }
})
